import script from "./InsuranceDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./InsuranceDetails.vue?vue&type=script&lang=ts&setup=true"

import "./InsuranceDetails.vue?vue&type=style&index=0&id=3bf27250&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf27250"]])

export default __exports__